module.exports = function getResource(label, vars = []) {
    const resources = {
        emptyBasketMessage: 'Votre panier est actuellement vide.',
        shopNewArrivals: 'Découvrir les nouveautés',
        pleaseSignIn: 'Please sign in if you are trying to retrieve a basket created in the past.',
        signInText: 'Sign In'
    };

    return resources[label];
};
